import { UrgencySignalsProps } from '@eventbrite/urgency-signals';
import React from 'react';
import { SALES_STATUS_CODE } from '../../types';
import { ActionsPanel } from '../EventDetails/ActionsPanel/ActionsPanel';
import { EnhancedExpiredEventsBadge } from '../ExpiredEvents/EnhancedExpiredEventsBadge';
import { UrgencySignals } from '../UrgencySignals/UrgencySignals';
import styles from './ExtraInfoAndActionBar.module.scss';

export type ExtraInfoAndActionBarProps = {
    urgencySignals: UrgencySignalsProps;
    salesMessage: string;
    salesMessageCode: SALES_STATUS_CODE;
    isShareable: boolean;
    shouldShowExpiredEventsBadge: boolean;
    isExpiredEvent: boolean;
};

export const ExtraInfoAndActionBar = ({
    urgencySignals,
    salesMessage,
    salesMessageCode,
    isShareable,
    shouldShowExpiredEventsBadge,
    isExpiredEvent,
}: ExtraInfoAndActionBarProps) => {
    return (
        <div
            data-testid="extra-info-and-action-bar"
            className={styles.extraInfoAndActionBar}
        >
            <div className={styles.leftSection}>
                {isExpiredEvent && shouldShowExpiredEventsBadge && (
                    <EnhancedExpiredEventsBadge
                        isEventDetailsPage={true}
                        salesMessage={salesMessage}
                        salesMessageCode={salesMessageCode}
                    />
                )}
                {!isExpiredEvent && (
                    <UrgencySignals urgencySignals={urgencySignals} />
                )}
            </div>
            <div className={styles.rightSection}>
                <ActionsPanel isShareable={isShareable} />
            </div>
        </div>
    );
};
